module.exports = __webpack_public_path__ + "img/top.5cbae862.png";